import axios from 'axios';
import {
  GET_HOME_PAGE_GAME_LIST_REQUEST,
  GET_HOME_PAGE_GAME_LIST_SUCCESS,
  GET_HOME_PAGE_GAME_LIST_FAILURE,
} from 'Store/constants';
import ProjectConfig from 'ProjectConfig';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getHomePageGameList = () => async dispatch => {
  dispatch({
    type: GET_HOME_PAGE_GAME_LIST_REQUEST,
  });

  try {
    const res = await axios.get(`${API_GATEWAY}/igames/mainpage`);

    dispatch({
      type: GET_HOME_PAGE_GAME_LIST_SUCCESS,
      payload: res.data
    });

  } catch (error) {
    dispatch({
      type: GET_HOME_PAGE_GAME_LIST_FAILURE,
      payload: error.response && error.response.data,
    });

    throw error;
  }
};
